<div class="error-dialog-container h-100">
  <div mat-dialog-title id="modal-header">
    <img alt="close icon" class="close-btn" matDialogClose src="assets/images/closeIcon.svg" />
  </div>
  <div mat-dialog-content id="modal-content">
    <img src="assets/images/warning.svg" alt="warning icon" />
    @if (data?.statusCode || data?.code || data?.status) {
      <span class="text-center">Error Code: {{ data?.statusCode || data?.code || data?.status }}</span>
    }
    <span class="text-center">{{ (data.error ?? data?.message ?? data | json)?.replace(regex, '') }}</span>
  </div>
</div>
